export { default as HotelSaleCreate } from './create';
export { default as HotelSaleList } from './list';
export { default as HotelSaleView } from './view';
